import tw from "twin.macro"

export const HowToContainer = tw.div`
  text-black [.section-dark-background &]:text-white text-center
  flex flex-col items-center
  w-full
  pb-10 px-4
`
